import { Anchor, Card, Group, Skeleton, Stack, Text, Title } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { MDash } from 'ui-components/components/mdash/mdash';
import { RelativeTime } from '../relative-time/relative-time';
import { messages } from '../../product-inventory-sync.messages';
import style from './sync-summary-card.module.css';

import type { ProductSyncSummary } from '../../product-inventory-sync-types';

const METRIC_SKELETON_WIDTH = 64;
const METRIC_SKELETON_HEIGHT = 24;

type SyncSummaryCardProps = {
  summary: ProductSyncSummary;
  isLoading: boolean;
  onEditConfigurationClick: () => void;
};

export const SyncSummaryCard = ({ summary, isLoading, onEditConfigurationClick }: SyncSummaryCardProps) => (
  <Card padding='lg' radius='sm' shadow='xs' withBorder>
    <Stack gap='sm'>
      <Title order={4}>
        <FormattedMessage {...messages.summaryCardTitle} />
      </Title>
      <Group align='baseline' gap='xs'>
        <Text size='sm'>
          <FormattedMessage {...messages.currentInStockLabel} />
        </Text>
        {isLoading ? (
          <Skeleton height={METRIC_SKELETON_HEIGHT} width={METRIC_SKELETON_WIDTH} />
        ) : (
          <Text className={style['metric-value']} fw={700} size='lg'>
            {summary.inStockQuantity === null ? <MDash /> : summary.inStockQuantity}
          </Text>
        )}
      </Group>
      <Group align='flex-start' gap='xs' justify='space-between' wrap='nowrap'>
        <Group gap={4}>
          <Text c='dimmed' size='xs'>
            <FormattedMessage {...messages.lastUpdatedLabel} />
          </Text>
          <Text c='dimmed' size='xs'>
            {summary.lastUpdatedAt ? <RelativeTime timestamp={summary.lastUpdatedAt} /> : <MDash />}
          </Text>
        </Group>
        <Text c='dimmed' size='xs' ta='right'>
          <FormattedMessage
            {...messages.configurationAside}
            values={{
              link: (
                <Anchor component='button' onClick={onEditConfigurationClick} type='button'>
                  <FormattedMessage {...messages.configurationLink} />
                </Anchor>
              ),
            }}
          />
        </Text>
      </Group>
    </Stack>
  </Card>
);
